(function () {
  window.omegaUtils = window.omegaUtils || {};
  const u = window.omegaUtils;

  /* ================= TOAST ================= */
  u.showToast = function (message, type = "success") {
    const old = document.querySelector(".omega-toast");
    if (old) old.remove();

    const toast = document.createElement("div");
    toast.className = `omega-toast ${type}`;
    toast.textContent = message;

    Object.assign(toast.style, {
      position: "fixed",
      top: "20px",
      right: "20px",
      zIndex: 99999,
      background: type === "success" ? "#000" : "#fff",
      color: type === "success" ? "#fff" : "#000",
      padding: "12px 16px",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,.15)",
    });

    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  };

  /* ================= CART ================= */
  u.handleAddToCart = async function (variantId, quantity = 1) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });

      const data = await res.json();
      if (data?.status === 422) {
        u.showToast(data.message || "Add to cart failed", "error");
        return false;
      }

      u.showToast("Added to cart", "success");
      return true;
    } catch {
      u.showToast("Add to cart error", "error");
      return false;
    }
  };

  u.handleBuyItNow = async function (variantId, quantity = 1) {
    const ok = await u.handleAddToCart(variantId, quantity);
    if (ok) window.location.href = "/checkout";
  };

  /* ================= FORMAT ================= */
  u.formatNumberWithCommas = function (num) {
    if (isNaN(num)) return "";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  u.getCurrencySymbol = function (code) {
    const map = { VND: "₫", USD: "$", EUR: "€", GBP: "£" };
    return ` ${map[code] || ""}`;
  };

  u.defaultImageUrl =
    "https://cdn.shopify.com/s/files/1/0931/0466/8987/files/instagram_feed_no_image_product.webp";

  /* ================= BASE64 ================= */
  u.encodeToBase64 = function (obj) {
    try {
      return btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    } catch {
      return "";
    }
  };

  u.decodeBase64 = function (str) {
    try {
      return JSON.parse(decodeURIComponent(escape(atob(str))));
    } catch {
      return null;
    }
  };

  /* ================= SOUND ================= */
  u.setupModalSoundToggle = function () {
    document.removeEventListener("click", u.handleModalSoundToggle);
    document.addEventListener("click", u.handleModalSoundToggle);
  };

  u.handleModalSoundToggle = function (e) {
    const btn = e.target.closest(".omega-mc-sound-toggle");
    if (!btn) return;

    const video = btn
      .closest(".omega-mc-media-container")
      ?.querySelector("video");
    if (!video) return;

    video.muted = !video.muted;
  };

  /* ================= THROTTLE ================= */
  u.throttleTrack = (function () {
    const map = new Map();
    return function (key, cb, ...args) {
      const now = Date.now();
      if (!map.has(key) || now - map.get(key) > 1000) {
        map.set(key, now);
        cb && cb(...args);
      }
    };
  })();

  /* ================= HELPERS ================= */
  u.openPermalink = function (url) {
    if (url && url !== "null" && url !== "undefined") {
      window.open(url, "_blank");
    }
  };

  u.handleAddScrollImagesDetailProduct = function () {};
  u.handleCheckOverflowWidthPricing = function () {};
  u.renderCustomizeProductPopupDetail = function () {};
  u.setupDragForModalInfo = function () {};
  u.expandProductSheet = function () {};

  /* ================= WAIT ================= */
  u.waitForElement = function (selector, timeout = 5000) {
    return new Promise((resolve, reject) => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);

      const obs = new MutationObserver(() => {
        const found = document.querySelector(selector);
        if (found) {
          obs.disconnect();
          resolve(found);
        }
      });

      obs.observe(document.body, { childList: true, subtree: true });

      setTimeout(() => {
        obs.disconnect();
        reject();
      }, timeout);
    });
  };

  u.formatDate = function (iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d)) return "";
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  u.checkIsMobile = function () {
    return window.innerWidth <= 768;
  };

  u.isAndroid = function () {
    return /android/i.test(navigator.userAgent);
  };
})();
